module.exports = __webpack_public_path__ + "static/img/app_dl.3216c0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app_dl.png
// module id = iEdL
// module chunks = 56